import {
  DEFAULT_EMOTION,
  DEFAULT_PITCH,
} from '@/shared/constants/default-voice';
import type {
  TTSEmotion,
  VideoEditorTTSVoice,
} from '@/shared/apis/tts/get-tts-voices';
import type { VoicePreset } from '@/entities/voice-preset/model/voice-preset';

/**
 * preset payload + 매칭된 voice → TTS 호출용 페이로드. TtsDialog 의 `TTSVoice` 와 구조 호환.
 *
 * 변환 도메인 지식이 voice-preset entity 에 속한다는 책임 경계 결정 (Phase B 단계 5 코드 리뷰 M-B).
 * shared/components 에서 entity 를 import 하는 FSD 역방향을 피하면서, BrandTemplate apply 흐름 등
 * 향후 진입점에서도 동일 변환을 재사용할 수 있도록 분리.
 */
export type VoicePresetTTSResult = {
  voice: VideoEditorTTSVoice;
  tempo: number;
  pitch: number | null;
  emotion: TTSEmotion;
  style?: string;
  /** caller (예: AiVoiceSettingPanel) 가 voice 이름 대신 사용자 부여 preset 이름 노출용. */
  presetName: string;
};

export function presetToTTSVoice(
  preset: VoicePreset,
  voice: VideoEditorTTSVoice,
): VoicePresetTTSResult {
  const matchedEmotion =
    voice.emotions.find((e) => e.code === preset.payload.emotionCode) ??
    voice.emotions[0];

  return {
    voice,
    tempo: preset.payload.tempo,
    pitch:
      voice.pitchMin != null ? (preset.payload.pitch ?? DEFAULT_PITCH) : null,
    emotion: (matchedEmotion ?? {
      code: DEFAULT_EMOTION,
      name: DEFAULT_EMOTION,
      nameKorean: DEFAULT_EMOTION,
    }) as TTSEmotion,
    style:
      voice.vendor === 'gemini'
        ? (preset.payload.style ?? undefined)
        : undefined,
    presetName: preset.name,
  };
}
